import AttentiveMobile from "./AttentiveMobile";

/**
 * @namespace Fragments.Fragments/AttentiveMobile
 */

export default AttentiveMobile;
